//image is in assets folder in public file ////
export const FoodItems = [
	{
		id: '1',
		Name: 'cabagae salad',
		rating: '4.9',
		Amount: '4.80',
		Quantities: '250g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '2',
		Name: 'Noodle salad',
		rating: '4.5',
		Amount: '6.30',
		Quantities: '300g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '3',
		Name: 'vegetable mix',
		rating: '5',
		Amount: '5.99',
		Quantities: '400g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '4',
		Name: 'seafood soup',
		rating: '4.4',
		Amount: '6.10',
		Quantities: '350g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '5',
		Name: 'bean soup',
		rating: '4.8',
		Amount: '4.40',
		Quantities: '350g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '6',
		Name: 'Stewed vegetables',
		rating: '3.9',
		Amount: '4.99',
		Quantities: '400g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '7',
		Name: 'chicken soup',
		rating: '4.2',
		Amount: '3.99',
		Quantities: '250g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '8',
		Name: 'seafood soup',
		rating: '4.4',
		Amount: '6.10',
		Quantities: '350g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '9',
		Name: 'bean soup',
		rating: '4.8',
		Amount: '4.40',
		Quantities: '350g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '10',
		Name: 'Stewed vegetables',
		rating: '3.9',
		Amount: '4.99',
		Quantities: '400g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '11',
		Name: 'chicken soup',
		rating: '4.2',
		Amount: '3.99',
		Quantities: '250g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
	{
		id: '12',
		Name: 'chicken soup',
		rating: '4.2',
		Amount: '3.99',
		Quantities: '250g',
		Image: 'Assets/food.svg',
		qty: 1,
		Details:
			'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem laborum, cumque dolorem ',
	},
];
